import '@/types/preview';
import '../../../services/animation';
import { preview, project } from '../../../store';
import { getRecoveryModule } from './recovery';
import { toTitleCase } from '@/utils/common';
export default class History {
    history;
    maxHistoryLength;
    node = null;
    currentIndex = -1;
    alteredHistory = false;
    historyTimeout = null;
    constructor(history = [], maxHistoryLength = 100) {
        this.history = history;
        this.maxHistoryLength = maxHistoryLength;
    }
    reset() {
        this.currentIndex = -1;
        this.history = [];
    }
    updateNode() {
        if (!this.node)
            return;
        project.updateTemplate(this.node.innerHTML);
        //update extraInformation
        let extraInformation = [];
        this.node.querySelectorAll('[data-amelement]').forEach(element => {
            const attribute = element.getAttribute('data-amelement');
            const ignored = ['sermonclip', 'caption', 'logo', 'sermon title'];
            if (attribute && ignored.includes(attribute))
                return false; // Skip this ignored case
            const type = element.getAttribute('data-amtype');
            const value = element.textContent?.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim() || '';
            extraInformation.push({
                key: attribute,
                label: toTitleCase(attribute),
                value,
                type
            });
            preview.set({
                extraInformation
            });
        });
    }
    observe(node) {
        this.node = node;
        getRecoveryModule().setElement(this.node);
    }
    addHistory(name) {
        if (this.alteredHistory) {
            this.history = this.history.slice(0, this.currentIndex + 1);
            this.alteredHistory = false;
        }
        const node = this.node.cloneNode(true);
        node.querySelectorAll('[data-amoriginal-prefocus-zindex]').forEach(element => {
            element.style.zIndex = element.getAttribute('data-amoriginal-prefocus-zindex');
        });
        node.querySelectorAll('[data-amoriginal-prefocus-zindex]').forEach(element => {
            element.style.zIndex = element.getAttribute('data-amoriginal-prefocus-zindex');
        });
        node.querySelectorAll('[data-amoriginal-prefocus-opacity]').forEach(element => {
            element.style.opacity = element.getAttribute('data-amoriginal-prefocus-opacity');
        });
        this.history.push({
            name,
            dom: node.innerHTML
        });
        this.currentIndex++;
        setTimeout(() => {
            project.updateTemplate(node.innerHTML);
        }, 1000);
    }
    undo() {
        if (this.currentIndex <= 0)
            return false;
        this.currentIndex--;
        this.alteredHistory = true;
        return this.getHistory(this.currentIndex);
    }
    getHistory(index) {
        return this.history[index];
    }
    clear() {
        this.node = null;
    }
}
